var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartBuildingForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19720_24416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25 67.1667V73.6667V99.6667C55.25 102.059 57.1913 104 59.5833 104H99.6667C102.059 104 104 102.059 104 99.6667V59.5833C104 57.1913 102.059 55.25 99.6667 55.25H59.5833C57.1913 55.25 55.25 57.1913 55.25 59.5833V67.1667Z",
    fill: "url(#paint0_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4167 0H4.33333C1.94133 0 0 1.94133 0 4.33333V26C0 28.392 1.94133 30.3333 4.33333 30.3333H44.4167C46.8087 30.3333 48.75 28.392 48.75 26V4.33333C48.75 1.94133 46.8087 0 44.4167 0Z",
    fill: "url(#paint1_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 55.2487V48.7487V41.1654C48.75 38.7734 46.8087 36.832 44.4167 36.832H4.33333C1.94133 36.832 0 38.7734 0 41.1654V62.832C0 65.224 1.94133 67.1654 4.33333 67.1654H44.4167C46.8087 67.1654 48.75 65.224 48.75 62.832V55.2487Z",
    fill: "url(#paint2_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 78.0013V99.668C0 102.06 1.94133 104.001 4.33333 104.001H44.4167C46.8087 104.001 48.75 102.06 48.75 99.668V78.0013C48.75 75.6093 46.8087 73.668 44.4167 73.668H4.33333C1.94133 73.668 0 75.6093 0 78.0013Z",
    fill: "url(#paint3_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 0H4.33333C1.937 0 0 1.94133 0 4.33333V26C0 28.392 1.937 30.3333 4.33333 30.3333H22.75V0Z",
    fill: "url(#paint4_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 36.832H4.33333C1.937 36.832 0 38.7734 0 41.1654V62.832C0 65.224 1.937 67.1654 4.33333 67.1654H22.75V36.832Z",
    fill: "url(#paint5_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.75 73.668H4.33333C1.937 73.668 0 75.6093 0 78.0013V99.668C0 102.06 1.937 104.001 4.33333 104.001H22.75V73.668Z",
    fill: "url(#paint6_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6667 0H59.5833C57.1913 0 55.25 1.94133 55.25 4.33333V30.3333V36.8333V44.4167C55.25 46.8087 57.1913 48.75 59.5833 48.75H99.6667C102.059 48.75 104 46.8087 104 44.4167V4.33333C104 1.94133 102.059 0 99.6667 0Z",
    fill: "url(#paint7_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.625 55.25H59.5833C57.1913 55.25 55.25 57.1913 55.25 59.5833V99.6667C55.25 102.059 57.1913 104 59.5833 104H79.625V55.25Z",
    fill: "url(#paint8_linear_19720_24416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.625 0H59.5833C57.1913 0 55.25 1.94133 55.25 4.33333V44.4167C55.25 46.8087 57.1913 48.75 59.5833 48.75H79.625V0Z",
    fill: "url(#paint9_linear_19720_24416)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19720_24416",
    x1: 65.8324,
    y1: 54.5856,
    x2: 72.3357,
    y2: 114.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19720_24416",
    x1: 10.5824,
    y1: -0.4134,
    x2: 13.118,
    y2: 37.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19720_24416",
    x1: 10.5824,
    y1: 36.4186,
    x2: 13.118,
    y2: 74.2423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19720_24416",
    x1: 10.5824,
    y1: 73.2546,
    x2: 13.118,
    y2: 111.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19720_24416",
    x1: 4.63334,
    y1: -0.231379,
    x2: 7.51667,
    y2: 29.9522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19720_24416",
    x1: 4.63334,
    y1: 36.6007,
    x2: 7.51667,
    y2: 66.7842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19720_24416",
    x1: 4.63334,
    y1: 73.4366,
    x2: 7.51667,
    y2: 103.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19720_24416",
    x1: 65.8324,
    y1: -0.664393,
    x2: 72.3357,
    y2: 59.6961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19720_24416",
    x1: 60.5412,
    y1: 54.5856,
    x2: 73.1149,
    y2: 112.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19720_24416",
    x1: 60.5412,
    y1: -0.664393,
    x2: 73.1149,
    y2: 57.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19720_24416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBuildingForm);
export default __webpack_public_path__ + "static/media/startBuildingForm.0d0990f8db599995d60f78e87d07ead7.svg";
export { ForwardRef as ReactComponent };